import { render, staticRenderFns } from "./ClientCallsIndicators.vue?vue&type=template&id=5aef10b5&scoped=true"
import script from "./ClientCallsIndicators.vue?vue&type=script&lang=js"
export * from "./ClientCallsIndicators.vue?vue&type=script&lang=js"
import style0 from "./ClientCallsIndicators.vue?vue&type=style&index=0&id=5aef10b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef10b5",
  null
  
)

export default component.exports